import { SoftwareFeaturePage } from './SoftwareFeaturePage';

export function CandidatesPipelinePage() {
  return (
    <SoftwareFeaturePage content={{
      eyebrow: 'Software — Candidates & Pipeline',
      title: 'One record per person. Every stage, every signal.',
      subtitle: 'Full ATS with AI-parsed profiles, timeline, and bulk pipeline actions.',
      description: 'From the first application to the final offer, every candidate record lives in one place — searchable, collaborative, and connected to every touchpoint your team has had.',
      heroBg: 'linear-gradient(150deg, #F5F3FF 0%, #EDE9FE 35%, #F5F3FF 65%, #EEF2FF 100%)',
      accentText: 'text-violet-600',
      stats: [
        { value: '50+', label: 'Fields per candidate profile' },
        { value: '10×', label: 'Faster shortlisting' },
        { value: 'Bulk', label: 'Stage-move & archive' },
        { value: '100%', label: 'Activity audit trail' },
      ],
      sections: [
        {
          heading: 'Candidate Records',
          bullets: [
            'AI-parsed resume into structured profile fields',
            'Timeline view of every interaction and stage change',
            'Notes, tags, and custom fields per candidate',
            'Duplicate detection and merge',
            'Source attribution tracked from first touch',
            'Full search across name, skill, location, and keyword',
          ],
        },
        {
          heading: 'Pipeline Management',
          bullets: [
            'Unlimited custom pipeline stages per job',
            'Drag-and-drop Kanban board view',
            'Bulk move, archive, tag, and email candidates',
            'Auto-advance rules based on score or time',
            'SLA alerts when candidates stall in a stage',
            'Per-stage recruiter assignment and ownership',
          ],
        },
        {
          heading: 'Collaboration',
          bullets: [
            'Shareable candidate links for hiring manager review',
            'In-line comments and @mentions on profiles',
            'Interview panel scorecards tied to each stage',
            'Role-based visibility — limit who sees what',
          ],
        },
      ],
    }} />
  );
}
